import { makeStyles } from '@material-ui/core';
import { corDaSituacao, FAMILIAS } from 'utils/situacao';

const { texto, solido } = corDaSituacao(FAMILIAS.ENCERRADO);

export const useStyles = makeStyles(() => ({
  hlCancel: {
    borderLeft: `2px solid ${texto}`,
    position: 'absolute',
    height: '29px',
    marginLeft: '53px',
    marginTop: '60px',
    transform: 'rotate(90deg)',
  },
  isCanceled: {
    borderLeft: `2px solid ${solido}`,
    height: 70,
    position: 'absolute',
    marginLeft: '30px',
    marginTop: -113,
  },
  avatarCancel: {
    width: '52px',
    height: '52px',
    border: `2px solid ${solido}`,
  },
  statusCancel: {
    width: '104px',
    height: '32px',
    borderRadius: '5px',
    fontSize: '12px',
    border: `2px solid ${texto}`,
    color: texto,
    marginLeft: '28px',
    textAlign: 'center',
  },
  iconCancel: {
    position: 'absolute',
    marginLeft: 20,
    marginTop: 62,
    color: texto,
  },
}));
